import { CheckCircle2, AlertCircle, Info, X } from 'lucide-react';

const VARIANTS = {
  success: {
    Icon: CheckCircle2,
    iconWrap: 'bg-emerald-500',
    panel: 'border-slate-200/90 bg-white',
    accent: 'border-l-emerald-500',
    title: 'text-slate-900',
    message: 'text-slate-700',
    close: 'text-slate-400 hover:text-slate-600 hover:bg-slate-100',
  },
  error: {
    Icon: AlertCircle,
    iconWrap: 'bg-rose-500',
    panel: 'border-slate-200/90 bg-white',
    accent: 'border-l-rose-500',
    title: 'text-slate-900',
    message: 'text-slate-700',
    close: 'text-slate-400 hover:text-slate-600 hover:bg-slate-100',
  },
  info: {
    Icon: Info,
    iconWrap: 'bg-indigo-500',
    panel: 'border-slate-200/90 bg-white',
    accent: 'border-l-indigo-500',
    title: 'text-slate-900',
    message: 'text-slate-700',
    close: 'text-slate-400 hover:text-slate-600 hover:bg-slate-100',
  },
};

export default function AppToast({ type = 'success', title, message, onDismiss }) {
  const variant = VARIANTS[type] ?? VARIANTS.info;
  const { Icon } = variant;
  const displayMessage = message || title || '';
  const displayTitle = title && message ? title : null;

  return (
    <div
      role="alert"
      className={`box-border w-full min-h-[3.5rem] overflow-hidden rounded-xl border border-slate-200/90 border-l-[3px] shadow-lg shadow-slate-900/[0.08] ${variant.panel} ${variant.accent}`}
    >
      <div className="flex h-full min-h-[3.5rem] w-full items-center gap-3 px-3.5 py-3">
        <div
          className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-white ${variant.iconWrap}`}
        >
          <Icon size={18} strokeWidth={2.25} />
        </div>

        <div className="min-w-0 flex-1">
          {displayTitle ? (
            <p className={`truncate text-xs font-semibold uppercase tracking-wide text-slate-500`}>
              {displayTitle}
            </p>
          ) : null}
          <p
            className={`text-[13px] leading-[1.35] ${displayTitle ? 'mt-0.5 font-medium' : 'font-medium'} ${variant.message}`}
          >
            {displayMessage}
          </p>
        </div>

        <button
          type="button"
          onClick={onDismiss}
          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md transition-colors ${variant.close}`}
          aria-label="Dismiss notification"
        >
          <X size={14} strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
}
